'use strict';
define(['modules/seochecker/results/traffic/traffic.controller'], function (TrafficInsightsController) {
    return {
        controller: TrafficInsightsController,
        templateUrl: 'app/modules/seochecker/results/traffic/traffic.html',
        bindings: {
            projectId: '<',
            projectUrl: '<',
        },
    };
});
